import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as navigation from "../../utils/navigation.js";
import * as rwData from "../../utils/rwData.js";

const LinkPolygon = (props) => {
  //========================================================================
  // State für den "gedrückt" Zustand
  const [isPressed, setIsPressed] = useState(false);

  //========================================================================
  // Seite wechseln
  const handleInputChange = () => {
    if (props.authWrite) {
      navigation.changePage("custom", props.props.path);
    }
  };

  //========================================================================
  // Maus-Event-Handler
  const handleMouseDown = () => {
    setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
    handleInputChange();
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleTouchStart = () => {
    setIsPressed(true);
  };

  const handleTouchEnd = () => {
    setIsPressed(false);
    handleInputChange();
  };

  //========================================================================
  // Skalierungsfaktor
  const scale = props.scaleFactor ?? 1;

  //========================================================================
  // Koordinaten für die Fläche einlesen (bis zu 5 Punkte)
  const points = [];

  try {
    props.element.points.forEach((pointObj) => {
      const key = Object.keys(pointObj)[0];
      const p = pointObj[key];

      if (p && p.x !== undefined && p.y !== undefined) {
        const x = parseFloat(String(p.x).replace("px", "")) * scale;
        const y = parseFloat(String(p.y).replace("px", "")) * scale;

        if (!isNaN(x) && !isNaN(y)) {
          points.push({ x, y });
        }
      }
    });
  } catch (error) {}

  const hasValidPolygon = points.length >= 3;

  // Bounding Box aus den Punkten berechnen -> eigene, unabhängige
  let boundingWidth = 0;
  let boundingHeight = 0;
  let clipPath = "none";

  if (hasValidPolygon) {
    const xs = points.map((p) => p.x);
    const ys = points.map((p) => p.y);
    boundingWidth = Math.max(...xs) - Math.min(...xs);
    boundingHeight = Math.max(...ys) - Math.min(...ys);

    clipPath = `polygon(${points
      .map((p) => `${p.x}px ${p.y}px`)
      .join(", ")})`;
  }

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
        width: 0,
        height: 0,
        overflow: "visible",
      }}
    >
      {hasValidPolygon && (
        <button
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: `${boundingWidth}px`,
            height: `${boundingHeight}px`,
            padding: 0,
            transform: `${props.element.transform} ${
              isPressed ? "scale(0.95)" : "scale(1)"
            }`,
            cursor: "pointer",
            transition: "transform 0.05s, box-shadow 0.05s",
            boxShadow: isPressed
              ? "inset 2px 2px 5px rgba(0,0,0,0.5)"
              : "2px 2px 5px rgba(0,0,0,0.3)",
            border: "solid 2px rgba(255, 255, 255, 0.2)",
            backgroundColor: props.style.backgroundColor,
            display: "flex",
            clipPath: clipPath,
            WebkitClipPath: clipPath,
          }}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          title={
            props.element.tooltip
              ? language.displayText(props.element.tooltip) +
                (props.element.tooltip2
                  ? "\n" + language.displayText(props.element.tooltip2)
                  : "") +
                (props.element.tooltip3
                  ? "\n" + language.displayText(props.element.tooltip3)
                  : "")
              : language.displayText(props.props.text) +
                (props.element.tooltip2
                  ? "\n" + language.displayText(props.element.tooltip2)
                  : "") +
                (props.element.tooltip3
                  ? "\n" + language.displayText(props.element.tooltip3)
                  : "") +
                (globalVars.cyclicUpdate || globalVars.editor
                  ? "\n" + ("Pfad: " + props.props.path)
                  : "")
          }
        >
          <div
            style={{
              paddingLeft: "3%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              boxSizing: "border-box",
              maxWidth: `calc(${props.element.width} - 5%)`,
            }}
          ></div>
        </button>
      )}
    </div>
  );
};

export default LinkPolygon;